<template>
  <div>
    <div class="loader-wrapper">
      <div class="loader"></div>
    </div>
  </div>
</template>

<style lang="scss">

  .loader-wrapper {
    position: fixed;
    inset: 0;
    width: 100vw;
    height: 100vh;
    height: 100dvh;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99;
    background: #fff;
  }
    .loader {
        border-top: 5px solid rgba(#999, 0.2);
        border-right: 5px solid rgba(#999, 0.2);
        border-bottom: 5px solid rgba(#999, 0.2);
        border-left: 5px solid #999;
        transform: translateZ(0) translateX(-50%) translateY(-100%);
        border-radius: 50%;
        height: 50px;
        width: 50px;
        margin-top: -25px;
        animation-name: spin;
        animation-duration: 2000ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
        &.-sm {
            height: 25px;
            width: 25px;
            border-top-width: 3px;
            border-right-width: 3px;
            border-bottom-width: 3px;
            border-left-width: 3px;
        }
        &.-white {
            border-top-color: rgba(white, 0.2);
            border-right-color: rgba(white, 0.2);
            border-bottom-color: rgba(white, 0.2);
            border-left-color: white;
        }
        &.-red {
            border-top-color: rgba(#ff3333, 0.2);
            border-right-color: rgba(#ff3333, 0.2);
            border-bottom-color: rgba(#ff3333, 0.2);
            border-left-color: #ff3333;
        }
        &.-base {
            border-top-color: rgba(var(--base-color), 0.2);
            border-right-color: rgba(var(--base-color), 0.2);
            border-bottom-color: rgba(var(--base-color), 0.2);
            border-left-color: var(--base-color);
        }
    }
</style>
